// CP-73: "Best Time to Book" must describe the cabin series behind
// Current / Lowest / Highest (and the percent arrow), not the last few
// rows of mixed-cabin history. A Neptune Suite or Ocean View point in
// that window made a flat or rising Interior look like "trending down".

export const COPY_INSUFFICIENT = 'Book now for the best available price';
export const COPY_DOWN = 'Prices are trending down. Consider waiting for a better deal.';
export const COPY_UP = 'Prices are trending up. Book now to lock in current rates.';
export const COPY_STABLE = 'Prices are stable. Book when convenient.';

// Rounded percent from the oldest point to the newest, same comparison as
// the Detail percent arrow. 0 is a real flat result. null means there is
// no trajectory to describe.
export function cabinTrajectoryPercent(points) {
  const series = Array.isArray(points) ? points : [];
  if (series.length < 2) return null;
  const sorted = [...series].sort((a, b) => {
    const dt = new Date(a.timestamp) - new Date(b.timestamp);
    if (dt !== 0) return dt;
    return String(a.cabin_type || '').localeCompare(String(b.cabin_type || ''));
  });
  const oldPrice = Number(sorted[0].price);
  const recentPrice = Number(sorted[sorted.length - 1].price);
  if (!Number.isFinite(oldPrice) || oldPrice === 0 || !Number.isFinite(recentPrice)) {
    return null;
  }
  return Math.round(((recentPrice - oldPrice) / oldPrice) * 100);
}

export function bookingTimeCopy(points) {
  const pct = cabinTrajectoryPercent(points);
  if (pct == null) return COPY_INSUFFICIENT;
  if (pct < 0) return COPY_DOWN;
  if (pct > 0) return COPY_UP;
  return COPY_STABLE;
}
